import React from 'react';
import Gallery from './Gallery';
import FieldInformation from './FieldInformation';
import { Media, Feature, OpeningTime } from '@/types/field';
import RateCard from './RateCard';
import Notes from './Notes';

interface MediaItem {
    media_hash: string;
    type: string;
    order: number;
    media: {
        hash: string;
        filename: string;
        mime_type: string;
        type: string;
        path: string;
    };
}

interface Note {
    type: string;
    title: string;
    message: string;
    dates: string;
}

interface FieldDetailsProps {
    media: MediaItem[];
    fieldInfo: {
        name: string;
        longitude: number;
        latitude: number;
        address: string;
        what3words: string;
        description: string;
        features: Feature[];
        times: OpeningTime[];
        prices: any[];
        notes: Note[];
    };
}

const FieldDetails: React.FC<FieldDetailsProps> = ({ media, fieldInfo }) => {
    return (
        <div className="w-full mx-auto bg-gray-100 px-8 py-12">
            <div className="flex flex-col lg:flex-row gap-8">
                <div className="w-full lg:w-1/2">
                    <FieldInformation {...fieldInfo} />
                </div>
                <div className="w-full lg:w-1/2">
                    <Gallery media={media} />
                    <RateCard fieldName={fieldInfo.name} pricings={fieldInfo.prices} />
                    <Notes notes={fieldInfo.notes} />
                </div>
            </div>
        </div>
    );
};

export default FieldDetails;